<template>
  <div class="plan-header-component">
    <div class="users-container">
      <ins-list ref="insList" @itemClick="itemClick" :show-facebook="true">
        <div v-show="publisherShow" v-if="publisher" class="user-item">
          <div
            class="image"
            v-lazy:background-image="publisher.image"
            :key="publisher.image"
          >
            <div
              v-if="publisher.socialNetwork === 1"
              class="ins-user-icon"
            ></div>
            <div
              v-if="publisher.socialNetwork === 2"
              class="fb-page-user-icon"
            ></div>
            <div
              v-if="publisher.socialNetwork === 3"
              class="fb-group-user-icon"
            ></div>
            <div
              v-if="publisher.socialNetwork === 4"
              class="tw-user-icon"
            ></div>
          </div>
          <div class="user-info">
            <div class="username-text">{{ publisher.username }}</div>
            <div class="state-text">{{ publisher.description }}</div>
          </div>
          <div class="icon"></div>
        </div>
      </ins-list>
    </div>
    <div class="login-modal" v-if="showModal">
      <div class="msg-container">
        <div>Add social account</div>
        <div class="modal-bottom">
          <el-button size="small" @click="logoutClick">Logout Apphi</el-button>
          <el-popover
            placement="top"
            width="230"
            v-model="platformModal"
            trigger="hover"
          >
            <div class="platform-list-container">
              <div class="platform-item" @click="addInsBtnClick">
                <div class="icon ins"></div>
                <div class="text">Instagram</div>
                <div class="right-icon"></div>
              </div>
              <div class="platform-item" @click="addFbPageBtnClick">
                <div class="icon fb"></div>
                <div class="text">Facebook Page</div>
                <div class="right-icon"></div>
              </div>
              <div class="platform-item" @click="addFbGroupBtnClick">
                <div class="icon fb-group"></div>
                <div class="text">Facebook Group</div>
                <div class="right-icon"></div>
              </div>
              <div class="platform-item" @click="addTwitterBtnClick">
                <div class="icon twitter"></div>
                <div class="text">Twitter</div>
                <div class="right-icon"></div>
              </div>
            </div>
            <el-button
              style="margin-left: 10px"
              slot="reference"
              type="primary"
              size="small"
              >Add</el-button
            >
          </el-popover>
        </div>
      </div>
    </div>
    <!-- <div v-show="upgradeShow && this.user.free" class="plan-info-container">
      <el-button type="primary" size="medium" @click="upgrade">Upgrade Plan</el-button>
    </div> -->
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme.less";
.login-modal {
  position: fixed;
  background: rgba(0, 0, 0, 0.1);
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  .msg-container {
    background: white;
    padding: 20px 30px;
    border-radius: 10px;
    .modal-bottom {
      padding-top: 20px;
    }
  }
}
.platform-list-container {
  padding: 10px 0;
  .platform-item {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    .icon {
      height: 22px;
      width: 22px;
      background-size: contain;
      &.ins {
        background-image: url("../../../public/images/common/list_ins@3x.png");
      }
      &.fb {
        background-image: url("../../../public/images/common/list_fb@3x.png");
      }
      &.fb-group {
        background-image: url("../../../public/images/common/list_fb_group@3x.png");
      }
      &.twitter {
        background-image: url("../../../public/images/common/list_twitter@3x.png");
      }
    }
    .right-icon {
      height: 18px;
      width: 10px;
      background-size: contain;
      background-image: url("../../../public/images/schedule_posts/Date_Right@3x.png");
    }
    .text {
      flex: 1;
      padding-left: 10px;
      font-size: 16px;
    }
  }
}
.plan-header-component {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 35px;
  background: white;
  border-bottom: 1px solid #eceff1;

  .users-container {
    flex: 1;
    display: flex;
    cursor: pointer;

    .user-item {
      display: flex;
      align-items: center;

      .image {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-position: center;
        background-size: contain;
        position: relative;
      }

      .user-info {
        width: 120px;
        padding-left: 10px;

        .username-text {
          font-size: 18px;
          font-weight: 500;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: start;
        }

        .state-text {
          font-size: 12px;
          color: @font-color-gray;
          margin-top: 2px;
        }
      }

      .icon {
        width: 15px;
        height: 15px;
        background-position: center;
        background-size: contain;
        background-image: url("../../../public/images/common/down_icon@3x.png");
        background-repeat: no-repeat;
        margin-left: 30px;
      }
    }

    .add-user-btn {
      margin-left: 35px;
      display: flex;
      align-items: center;
      font-weight: 500;
      cursor: pointer;

      &:active,
      &:hover {
        opacity: 0.8;
      }

      .icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../../../public/images/schedule_posts/Add_Detail@3x.png);
        background-size: contain;
      }

      .text {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }

  .plan-info-container {
    display: flex;
    padding-left: 20px;
  }
}
</style>

<script>
import insList from "./ins_list/Index";
import { mapGetters } from "vuex";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_PUBLISHER_ID,
  CURRENT_USER_INFO_SIMPLE,
} from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/errors";

export default {
  name: "PlanHeaderComponent",
  components: { insList },
  props: {
    publisherShow: {
      // 显示publisher
      type: Boolean,
      default: true,
    },
    upgradeShow: {
      // 显示upgrade
      type: Boolean,
      default: true,
    },
    type: {
      type: String, // 类型
      default: "",
    },
    switchPublisher: {
      type: Function,
      default() {
        return Promise.resolve();
      },
    },
  },
  data() {
    return {
      showModal: false,
      platformModal: false,
    };
  },
  computed: {
    ...mapGetters({
      publisher: CURRENT_PUBLISHER_SIMPLE,
      user: CURRENT_USER_INFO_SIMPLE,
      publisherId: CURRENT_PUBLISHER_ID,
    }),
    /**
     * 容器样式
     */
    containerStyle() {
      if (this.type === "add_instagram") {
        return {
          "padding-left": "25px",
        };
      }
    },
  },
  methods: {
    /**
     * 添加点击事件
     */
    addInsBtnClick() {
      this.platformModal = false;
      this.$bus.$emit("showAddIns", {});
    },
    logoutClick() {
      this.showModal = false;
      window.location.href = "/";
    },
    addFbPageBtnClick() {
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookPage", {
        callback: () => {
          this.showModal = false;
          this.validatePublisher();
        },
      });
    },
    addFbGroupBtnClick() {
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookGroup", {
        callback: () => {
          this.showModal = false;
          this.validatePublisher();
        },
      });
    },
    addTwitterBtnClick() {
      this.platformModal = false;
      this.$bus.$emit("showAddTwitter", {
        callback: () => {
          this.showModal = false;
          this.validatePublisher();
        },
      });
    },
    /**
     * 更新按钮点击事件
     */
    upgrade() {
      this.$router.push({ name: "UpgradePage" });
    },
    /**
     * ins列表单条点击事件
     * @param item
     */
    async itemClick(item) {
      try {
        // 如果选择publisher和上次相同则不做任何改变
        if (item.publisherId === this.publisherId) {
          return;
        }
        // 验证是否可以进行切换
        await this.switchPublisher();
        // 修改当前选中人
        this.$store.commit(CURRENT_PUBLISHER_ID, item.publisherId);
        // 判断当前切换的用户是否为非ins用户
      } catch (e) {
        showErrorMsg(e);
      }
    },
    async validatePublisher() {
      // 如果发现没有选中任何用户则弹出添加提示
      if (this.publisher === null) {
        this.showModal = true;
        // try {
        //   await this.$msgbox({
        //     title: 'Add Instagram',
        //     message: '',
        //     showClose: false,
        //     distinguishCancelAndClose: true,
        //     closeOnClickModal: false,
        //     showCancelButton: true,
        //     confirmButtonText: 'Add social account',
        //     cancelButtonText: 'Logout Apphi'
        //   })
        //   this.showInsLogin()
        // } catch (action) {
        //   if (action === 'cancel') {
        //     window.location.href = '/'
        //   }
        // }
      }
    },
    showInsLogin() {
      this.$bus.$emit("showAddIns", {
        afterClose: () => {
          this.validatePublisher();
        },
      });
    },
  },
  mounted() {
    if (this.$route.name === "SchedulePage") {
      this.validatePublisher();
    }
  },
  created() {
    // 添加全局监听，打开schedule表单
    this.$bus.$on("closeEmpytModal", () => {
      this.showModal = false;
    });
  },
};
</script>
